export default __webpack_public_path__ + "static/transaction-page-completed-605f5aab9c0d4766537d6198072d6fc3.png";